var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from "moment";
import { GetCoalescedMealQuantity } from "../utils/RecipeModule-utils";
/**
 * Removes a recipe assignment for a meal on the selectedDay.
 * This function does not dispatch a store update, it only returns the updated meals.
 * This allows us to reuse this logic for the Recipe module and the Customization modal.
 *
 * @param enableAssignRecipes
 * @param enableRemoveMeals
 * @param onlyShowDeliveryDays
 * @param template
 * @param cartMeals
 * @param daysOfWeek
 * @param selectedDay
 * @param recipe
 * @param programMealId
 * @param assignmentId
 * @returns
 */
export const decrementRecipe_V2 = ({ enableAssignRecipes, enableRemoveMeals, onlyShowDeliveryDays, template, clonedMeals, daysOfWeek, selectedDay, recipe, programMealId, assignmentId, }) => __awaiter(void 0, void 0, void 0, function* () {
    let mealDate = moment(selectedDay);
    let recipeId = recipe.RecipeId;
    let mealPrice = 0;
    //For Klaviyo event
    let mealName = "";
    //For Customization modal
    let currentAssignmentQuantity = 0;
    const meals = clonedMeals
        .map((meal) => {
        if (moment(moment(meal.MealDate)).isSame(mealDate, "date") && meal.ProgramMealId === programMealId) {
            mealPrice = meal.Price;
            mealName = meal.ProgramMealName;
            if (enableAssignRecipes) {
                let templateMeal = template.find((meal) => meal.ProgramMealId === programMealId && meal.DayOfWeek === mealDate.day());
                let minMealQuantity = 0;
                if (daysOfWeek.some((day) => day === mealDate.day())) {
                    minMealQuantity = (templateMeal && templateMeal.Quantity) || 0;
                    if (onlyShowDeliveryDays && meal.CoalescedMealDates && meal.CoalescedMealDates.length > 0) {
                        minMealQuantity = GetCoalescedMealQuantity(template, meal);
                    }
                }
                if (meal.Quantity > minMealQuantity) {
                    meal.Quantity -= 1;
                }
                else if (enableRemoveMeals) {
                    meal.Quantity -= 1;
                    meal.NumRemovedAssignments || (meal.NumRemovedAssignments = 0);
                    meal.NumRemovedAssignments += 1;
                }
            }
            else {
                meal.Quantity -= 1;
            }
            // If we have an assignmentId we need to ensure we grab the one that matches.
            // Otherwise we only care about the other conditions
            let assignment = meal.RecipeAssignments &&
                meal.RecipeAssignments.find((a) => a.RecipeId === recipeId &&
                    a.ProgramMealId === programMealId &&
                    (!!assignmentId ? a.AssignmentId === assignmentId : true));
            if (assignment) {
                assignment.Quantity -= 1;
                currentAssignmentQuantity = assignment.Quantity;
                // If the user decrements an assignment then it is no longer an automatic selection
                assignment.IsAutomaticSelection = false;
            }
        }
        return meal;
    })
        .filter((meal) => enableRemoveMeals || (!enableRemoveMeals && meal.Quantity > 0));
    return {
        meals,
        mealPrice,
        mealName,
        mealDate: moment(selectedDay),
        currentAssignmentQuantity,
    };
});
